
import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Close from 'images/close.svg'

const MissionBlockEditModalErrorNew = ({
  text,
  onConfirm,
  title,
  okButton
}) => (
  <Modal  size='sm' className='mission-block-container-modal'>
    <div className='mission-block-new-modal'>
        <img src={Close} />
        <p className='mission-modal-title-error'>{title}</p>
        <p className='mission-modal-text'>{text}</p>
        <button style={{backgroundColor: '#B42A27'}} onClick={onConfirm}>{okButton}</button>
    </div>

  </Modal>

  )

MissionBlockEditModalErrorNew.propTypes = {
  text: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  okButton: PropTypes.string.isRequired
}
export default MissionBlockEditModalErrorNew
